<script setup lang="ts">

import CustomerCertificationOnboarding from "@/customer-certification/views/CustomerCertificationOnboarding.vue";
import Customer from "@/customer/interfaces/Customer";

defineProps<{
    customer: Customer,
    open?: boolean;
}>();

defineEmits<{
    (e: 'update:open', value: boolean): void;
    (e: 'certified'): void;
}>();
</script>

<template>
  <v-dialog fullscreen :retain-focus="false" transition="dialog-bottom-transition" z-index="10" :model-value="open">
    <template #activator="{props: activatorProps}">
      <slot name="activator" :props="activatorProps" />
    </template>
    <template #default="{ isActive }">
      <CustomerCertificationOnboarding
        :customer="customer"
        @close="isActive.value = false; $emit('update:open', false)"
        @certified="$emit('certified')"
      />
    </template>
  </v-dialog>
</template>

<style scoped>

</style>
